import React from "react";
import { message, Popconfirm } from "antd";
import { gql, useMutation } from "@apollo/client";

const DELETEINCOME = gql`
  mutation removeIncome($id: ID!) {
    removeIncome(id: $id)
  }
`;

function DeleteIncome({ id, children, onDeleteIncome, closeDrawer }) {
  const [runDeleteIncome, deleteIncome] = useMutation(DELETEINCOME, {
    onCompleted({ removeIncome }) {
    
      if (removeIncome) {
        message.success(`درآمد جانبی حذف شد.`);
        onDeleteIncome();
        closeDrawer();
      }
    },
    onError(err) {
      console.log(err.message);
    },
  });

  const doDeleteIncome= () => {
    runDeleteIncome({
      variables: { id },
    });
  };
  return (
    <>
      <Popconfirm
        title={"حذف درآمد جانبی"}
        okText="حذف"
        cancelText="خیر"
        onConfirm={doDeleteIncome}
      >
        <span>{children}</span>
      </Popconfirm>
    </>
  );
}

export default DeleteIncome;
